<template>
  <div :style="{ marginTop: '20px', paddingBottom: '80px' }">

    <div v-if="!loading">

      <!-- Global toggle -->
      <div class="d-flex align-items-center mb-3 alerts-global-row">
        <span class="alerts-global-label">Alerts Enabled</span>
        <b-form-select v-model="model.alerts_enabled" :options="boolean_options" style="width:100px"></b-form-select>
      </div>

      <!-- Late Alerts -->
      <b-card v-if="model.late_alert_enabled" no-body class="alert-section-card mb-2" data-section="isLateAlertVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isLateAlertVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isLateAlertVisible }">&#9654;</span>
          <span class="alert-section-title">Late Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.late_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isLateAlertVisible" :visible="!!toggle.isLateAlertVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr>
                <td class="alert-label">Filter Start Yard(s)</td>
                <td>
                  <span class="help-block">Alerts will send for all start locations if no yards are selected</span><br/>
                  <label v-for="option in yard_options" :key="option.value">
                    <input type="checkbox" :value="option.value" v-model="selectedYardOptions">
                    {{ option.text }}&nbsp;&nbsp;&nbsp;
                  </label>
                </td>
              </tr>
              <tr data-field="late_alert_minutes">
                <td class="alert-label">Trigger Minutes After Planned Time</td>
                <td>
                  <b-form-input v-model="model.late_alert_minutes" type="text" :state="numericState('late_alert_minutes')" @input="validateNumeric('late_alert_minutes', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('late_alert_minutes')">{{ numericFeedback('late_alert_minutes') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="late_alert_time_window">
                <td class="alert-label">Alert Time Window</td>
                <td><b-form-input v-model="model.late_alert_time_window" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.late_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type == 'TBN'" data-field="late_alert_driver_start_time_enabled">
                <td class="alert-label">Trigger Using Driver Start Time</td>
                <td><b-form-select v-model="model.late_alert_driver_start_time_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type == 'TBN'" data-field="late_alert_first_departure_time_enabled">
                <td class="alert-label">Trigger Using First Departure Time</td>
                <td><b-form-select v-model="model.late_alert_first_departure_time_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="late_alert_suppress_if_hos_login">
                <td class="alert-label">Suppress If HOS Login Detected</td>
                <td><b-form-select v-model="model.late_alert_suppress_if_hos_login" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type == 'TBN'" data-field="late_alert_suppress_if_hos_assigned">
                <td class="alert-label">Suppress If HOS Assignment Detected</td>
                <td><b-form-select v-model="model.late_alert_suppress_if_hos_assigned" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="late_alert_suppress_if_dvir_created">
                <td class="alert-label">Suppress If Pre Trip DVIR Created</td>
                <td><b-form-select v-model="model.late_alert_suppress_if_dvir_created" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="late_alert_suppress_if_vehicle_key_on">
                <td class="alert-label">Suppress If Vehicle Is Turned On</td>
                <td><b-form-select v-model="model.late_alert_suppress_if_vehicle_key_on" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="late_alert_suppress_if_vehicle_speed">
                <td class="alert-label">Suppress If Vehicle Moves</td>
                <td><b-form-select v-model="model.late_alert_suppress_if_vehicle_speed" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="late_alert_suppress_if_vehicle_left_yard">
                <td class="alert-label">Suppress If Vehicle Leaves Yard</td>
                <td><b-form-select v-model="model.late_alert_suppress_if_vehicle_left_yard" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="late_alert_private_hires_only">
                <td class="alert-label">Private Hires Only</td>
                <td><b-form-select v-model="model.late_alert_private_hires_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="late_alert_booking_type_filter">
                <td class="alert-label">Booking Type Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.late_alert_booking_type_filter"
                    fieldKey="late_alert_booking_type_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="late_alert_booking_id_filter">
                <td class="alert-label">Booking ID Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.late_alert_booking_id_filter"
                    fieldKey="late_alert_booking_id_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="late_alert_client_id_filter">
                <td class="alert-label">Client ID Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.late_alert_client_id_filter"
                    fieldKey="late_alert_client_id_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="late_alert_driver_tag_filter">
                <td class="alert-label">Driver Tag Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.late_alert_driver_tag_filter"
                    fieldKey="late_alert_driver_tag_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="late_alert_vehicle_tag_filter">
                <td class="alert-label">Vehicle Tag Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.late_alert_vehicle_tag_filter"
                    fieldKey="late_alert_vehicle_tag_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="late_alert_vehicle_filter">
                <td class="alert-label">Vehicle ID Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.late_alert_vehicle_filter"
                    fieldKey="late_alert_vehicle_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="late_alert_by_booking_type">
                <td class="alert-label">Send By Booking Type</td>
                <td><b-form-input v-model="model.late_alert_by_booking_type" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_by_booking_base">
                <td class="alert-label">Send By Booking Base</td>
                <td><b-form-textarea v-model="model.late_alert_by_booking_base" style="field-sizing: content"/></td>
              </tr>
              <tr data-field="late_alert_by_company_id">
                <td class="alert-label">Send By Company ID</td>
                <td><b-form-input v-model="model.late_alert_by_company_id" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_failed_sms_recipients">
                <td class="alert-label">SMS Failure Recipients</td>
                <td><b-form-input v-model="model.late_alert_failed_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.late_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_voice_recipients">
                <td class="alert-label">Voice Recipients</td>
                <td><b-form-input v-model="model.late_alert_voice_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_voice_base_config">
                <td class="alert-label">Voice Base Config</td>
                <td>
                  <JsonObjectListEditor v-model="model.late_alert_voice_base_config" fieldKey="late_alert_voice_base_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="voice_base_config_columns"/>
                  <b-form-invalid-feedback :state="jsonState('late_alert_voice_base_config')">{{ jsonFeedback('late_alert_voice_base_config') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="late_alert_voice_message">
                <td class="alert-label">Voice Message Text</td>
                <td>
                  <PfsRichEditor ref="lateAlertVoiceRef" v-model="model.late_alert_voice_message" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="lateAlertVoiceFields" :editor-ref="$refs.lateAlertVoiceRef" :tenant-type="tenant_type"/>
                </td>
              </tr>
              <tr data-field="late_alert_voice_time_window">
                <td class="alert-label">Voice Time Window</td>
                <td><b-form-input v-model="model.late_alert_voice_time_window" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_sms">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.late_alert_sms" type="text"></b-form-input></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="late_alert_email_contract">
                <td class="alert-label">Contract Email Recipients</td>
                <td><b-form-input v-model="model.late_alert_email_contract" type="text"></b-form-input></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="late_alert_email_private">
                <td class="alert-label">Private Hire Email Recipients</td>
                <td><b-form-input v-model="model.late_alert_email_private" type="text"></b-form-input></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="late_alert_sms_contract">
                <td class="alert-label">Contract SMS Recipients</td>
                <td><b-form-input v-model="model.late_alert_sms_contract" type="text"></b-form-input></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="late_alert_sms_private">
                <td class="alert-label">Private Hire SMS Recipients</td>
                <td><b-form-input v-model="model.late_alert_sms_private" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_slack_url">
                <td class="alert-label">Slack Channel URL</td>
                <td><b-form-input v-model="model.late_alert_slack_url" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_msteams_url">
                <td class="alert-label">MS Teams Channel URL</td>
                <td><b-form-input v-model="model.late_alert_msteams_url" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><PfsRichEditor ref="lateAlertSmsRef" v-model="model.late_alert_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsAlertFields.lateAlert" :editor-ref="$refs.lateAlertSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Advanced Late Alerts -->
      <b-card no-body class="alert-section-card mb-2">
        <b-card-header class="alert-section-header alert-section-header--static d-flex align-items-center">
          <span class="alert-section-title">Advanced Late Alerts</span>
          <div class="ml-auto">
            <b-button variant="outline-secondary" size="sm" class="mr-2" @click="manage_vehicle_late_events = !manage_vehicle_late_events">Manage Events</b-button>
            <b-btn v-if="isEffectiveAdmin && (tenant_type == 'TBN' || tenant_type == 'CM')" variant="outline-secondary" size="sm" class="mr-2" :disabled="loading" @click="confirmDefaults('Add any missing default Advanced Late Alerts? Existing events will not be changed.', setupDefaultVehicleLateAlerts, 'Add Defaults')">Set Defaults</b-btn>
            <b-form-select v-model="model.vehicle_late_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
      </b-card>

      <!-- Booking State Alerts (TBN only) -->
      <b-card v-if="tenant_type == 'TBN' || tenant_type == 'CM'" no-body class="alert-section-card mb-2">
        <b-card-header class="alert-section-header alert-section-header--static d-flex align-items-center">
          <span class="alert-section-title">Booking State Alerts</span>
          <div class="ml-auto">
            <b-button variant="outline-secondary" size="sm" class="mr-2" @click="manage_booking_state_events = !manage_booking_state_events">Manage Events</b-button>
            <b-form-select v-model="model.booking_state_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
      </b-card>

      <!-- Vehicle Activity Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isVehActivityVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isVehActivityVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isVehActivityVisible }">&#9654;</span>
          <span class="alert-section-title">Vehicle Activity Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mr-2" @click="confirmDefaults('Set default values for Vehicle Activity Alerts? This will overwrite current settings.', apply_eld_alert_defaults)">Set Defaults</b-btn>
            <b-form-select v-model="model.eld_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isVehActivityVisible" :visible="!!toggle.isVehActivityVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="eld_alert_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.eld_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="eld_alert_idle_alert_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.eld_alert_idle_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="eld_alert_idle_alert_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.eld_alert_idle_alert_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="eld_alert_fault_alert_email_recipients">
                <td class="alert-label">ELD Fault Email Recipients</td>
                <td><b-form-input v-model="model.eld_alert_fault_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="eld_alert_fault_alert_sms_recipients">
                <td class="alert-label">ELD Fault SMS Recipients</td>
                <td><b-form-input v-model="model.eld_alert_fault_alert_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="eld_alert_idle_alert_sms_template">
                <td class="alert-label">Idle Alert SMS Template</td>
                <td><PfsRichEditor ref="eldIdleSmsRef" v-model="model.eld_alert_idle_alert_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsAlertFields.eldIdle" :editor-ref="$refs.eldIdleSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr data-field="eld_alert_idle_alert_sms_geofence_template">
                <td class="alert-label">Idle / Geofence Alert SMS Template</td>
                <td><PfsRichEditor ref="eldIdleGeofenceSmsRef" v-model="model.eld_alert_idle_alert_sms_geofence_template"/>
                  <PfsFieldHelp :fields="pfsAlertFields.eldGeofence" :editor-ref="$refs.eldIdleGeofenceSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr data-field="eld_alert_fault_alert_sms_template">
                <td class="alert-label">ELD Fault SMS Template</td>
                <td><PfsRichEditor ref="eldFaultSmsRef" v-model="model.eld_alert_fault_alert_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsAlertFields.eldFault" :editor-ref="$refs.eldFaultSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr data-field="eld_alert_fault_alert_mappings">
                <td class="alert-label">ELD Fault Description Mapping</td>
                <td><b-form-input v-model="model.eld_alert_fault_alert_mappings" type="text"></b-form-input></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Vehicle Inactivity Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isVehInactiveVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isVehInactiveVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isVehInactiveVisible }">&#9654;</span>
          <span class="alert-section-title">Vehicle Inactivity Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mr-2" @click="confirmDefaults('Set default values for Vehicle Inactivity Alerts? This will overwrite current settings.', apply_vehicle_inactivity_defaults)">Set Defaults</b-btn>
            <b-form-select v-model="model.vehicle_inactivity_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isVehInactiveVisible" :visible="!!toggle.isVehInactiveVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="vehicle_inactivity_alert_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.vehicle_inactivity_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.vehicle_inactivity_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.vehicle_inactivity_alert_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_geofence">
                <td class="alert-label">Geofence</td>
                <td><b-form-input v-model="model.vehicle_inactivity_alert_geofence" type="text"></b-form-input></td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_vehicle_filter">
                <td class="alert-label">Vehicle Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.vehicle_inactivity_alert_vehicle_filter"
                    fieldKey="vehicle_inactivity_alert_vehicle_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_vehicle_tag_filter">
                <td class="alert-label">Vehicle Tag Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.vehicle_inactivity_alert_vehicle_tag_filter"
                    fieldKey="vehicle_inactivity_alert_vehicle_tag_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_active_time_windows">
                <td class="alert-label">Active Time Window</td>
                <td><b-form-input v-model="model.vehicle_inactivity_alert_active_time_windows" type="text"></b-form-input></td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_duration_threshold">
                <td class="alert-label">Duration Threshold</td>
                <td>
                  <b-form-input v-model="model.vehicle_inactivity_alert_duration_threshold" type="text" :state="numericState('vehicle_inactivity_alert_duration_threshold')" @input="validateNumeric('vehicle_inactivity_alert_duration_threshold', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('vehicle_inactivity_alert_duration_threshold')">{{ numericFeedback('vehicle_inactivity_alert_duration_threshold') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_speed_threshold">
                <td class="alert-label">Speed Threshold</td>
                <td>
                  <b-form-input v-model="model.vehicle_inactivity_alert_speed_threshold" type="text" :state="numericState('vehicle_inactivity_alert_speed_threshold')" @input="validateNumeric('vehicle_inactivity_alert_speed_threshold', $event, 0, 200)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('vehicle_inactivity_alert_speed_threshold')">{{ numericFeedback('vehicle_inactivity_alert_speed_threshold') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><PfsRichEditor ref="vehicleInactivitySmsRef" v-model="model.vehicle_inactivity_alert_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsAlertFields.vehicleInactivity" :editor-ref="$refs.vehicleInactivitySmsRef" :tenant-type="tenant_type"/></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- HOS Duration Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isHOSDurationVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isHOSDurationVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isHOSDurationVisible }">&#9654;</span>
          <span class="alert-section-title">HOS Duration Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-button variant="outline-secondary" size="sm" class="mr-2" @click="manage_hos_events = !manage_hos_events">Manage Alert Events</b-button>
            <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mr-2" @click="confirmDefaults('Set default values for HOS Duration Alerts? This will overwrite current settings.', apply_hos_alert_defaults)">Set Defaults</b-btn>
            <b-form-select v-model="model.driver_hos_alerts_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isHOSDurationVisible" :visible="!!toggle.isHOSDurationVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="driver_hos_alerts_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.driver_hos_alerts_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="driver_hos_alerts_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.driver_hos_alerts_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_hos_alerts_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.driver_hos_alerts_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_hos_alerts_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><PfsRichEditor ref="driverHosSmsRef" v-model="model.driver_hos_alerts_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsAlertFields.driverHos" :editor-ref="$refs.driverHosSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Unplanned Activity Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isUnplannVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isUnplannVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isUnplannVisible }">&#9654;</span>
          <span class="alert-section-title">Unplanned Activity Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mr-2" @click="confirmDefaults('Set default values for Unplanned Activity Alerts? This will overwrite current settings.', apply_unplanned_activity_defaults)">Set Defaults</b-btn>
            <b-form-select v-model="model.unplanned_vehicle_activity_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isUnplannVisible" :visible="!!toggle.isUnplannVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="unplanned_vehicle_activity_alert_yard_mile_radius">
                <td class="alert-label">Yard Mile Radius</td>
                <td>
                  <b-form-input v-model="model.unplanned_vehicle_activity_alert_yard_mile_radius" type="text" :state="numericState('unplanned_vehicle_activity_alert_yard_mile_radius')" @input="validateNumeric('unplanned_vehicle_activity_alert_yard_mile_radius', $event, 0, 100)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('unplanned_vehicle_activity_alert_yard_mile_radius')">{{ numericFeedback('unplanned_vehicle_activity_alert_yard_mile_radius') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="unplanned_vehicle_activity_alert_vehicle_filter">
                <td class="alert-label">Vehicle Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.unplanned_vehicle_activity_alert_vehicle_filter"
                    fieldKey="unplanned_vehicle_activity_alert_vehicle_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="unplanned_vehicle_activity_alert_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.unplanned_vehicle_activity_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="unplanned_vehicle_activity_alert_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.unplanned_vehicle_activity_alert_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="unplanned_vehicle_activity_alert_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><PfsRichEditor ref="unplannedVehicleSmsRef" v-model="model.unplanned_vehicle_activity_alert_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsAlertFields.unplannedVehicle" :editor-ref="$refs.unplannedVehicleSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Gateway Disconnect Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isGatewayDisconnectVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isGatewayDisconnectVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isGatewayDisconnectVisible }">&#9654;</span>
          <span class="alert-section-title">Gateway Disconnect Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mr-2" @click="confirmDefaults('Set default values for Gateway Disconnect Alerts? This will overwrite current settings.', apply_gateway_disconnect_defaults)">Set Defaults</b-btn>
            <b-form-select v-model="model.gateway_disconnect_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isGatewayDisconnectVisible" :visible="!!toggle.isGatewayDisconnectVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="gateway_disconnect_alert_threshold_minutes">
                <td class="alert-label">Treat as disconnected after (minutes)</td>
                <td>
                  <b-form-input v-model="model.gateway_disconnect_alert_threshold_minutes" type="number" min="1" max="1440" step="1" style="width:100px" placeholder="10" :state="numericState('gateway_disconnect_alert_threshold_minutes')" @keydown="blockNonNumericKeys($event, true)" @input="validateNumeric('gateway_disconnect_alert_threshold_minutes', $event, 1, 1440, true)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('gateway_disconnect_alert_threshold_minutes')">{{ numericFeedback('gateway_disconnect_alert_threshold_minutes') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="gateway_disconnect_alert_grace_period_minutes">
                <td class="alert-label">Driver on-duty grace period (minutes)</td>
                <td>
                  <b-form-input v-model="model.gateway_disconnect_alert_grace_period_minutes" type="number" min="0" max="1440" step="1" style="width:100px" placeholder="10" :state="numericState('gateway_disconnect_alert_grace_period_minutes')" @keydown="blockNonNumericKeys($event, true)" @input="validateNumeric('gateway_disconnect_alert_grace_period_minutes', $event, 0, 1440, true)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('gateway_disconnect_alert_grace_period_minutes')">{{ numericFeedback('gateway_disconnect_alert_grace_period_minutes') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="gateway_disconnect_alert_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.gateway_disconnect_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="gateway_disconnect_alert_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.gateway_disconnect_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="gateway_disconnect_alert_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.gateway_disconnect_alert_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="gateway_disconnect_alert_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><PfsRichEditor ref="gatewayDisconnectSmsRef" v-model="model.gateway_disconnect_alert_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsAlertFields.gatewayDisconnect" :editor-ref="$refs.gatewayDisconnectSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Missing DVIR Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isMissingDVIRVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isMissingDVIRVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isMissingDVIRVisible }">&#9654;</span>
          <span class="alert-section-title">Missing DVIR Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mr-2" @click="confirmDefaults('Set default values for Missing DVIR Alerts? This will overwrite current settings.', apply_missing_dvir_defaults)">Set Defaults</b-btn>
            <b-form-select v-model="model.missing_dvir_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isMissingDVIRVisible" :visible="!!toggle.isMissingDVIRVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="missing_dvir_alert_test_mode">
                <td class="alert-label">Test Mode</td>
                <td><b-form-select v-model="model.missing_dvir_alert_test_mode" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="missing_dvir_alert_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.missing_dvir_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="missing_dvir_alert_pre_trip_enabled">
                <td class="alert-label">Pre Trip Enabled</td>
                <td><b-form-select v-model="model.missing_dvir_alert_pre_trip_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="missing_dvir_alert_post_trip_enabled">
                <td class="alert-label">Post Trip Enabled</td>
                <td><b-form-select v-model="model.missing_dvir_alert_post_trip_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="missing_dvir_alert_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.missing_dvir_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="missing_dvir_alert_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.missing_dvir_alert_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="missing_dvir_alert_vehicle_tag_filter">
                <td class="alert-label">Vehicle Tag Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.missing_dvir_alert_vehicle_tag_filter"
                    fieldKey="missing_dvir_alert_vehicle_tag_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="missing_dvir_alert_skip_drivers">
                <td class="alert-label">Skip Drivers</td>
                <td>
                  <!-- Backend does a substring check (driver name found anywhere within
                       this field's raw value) — same shape as skip_routes. "Allow all
                       except..." mode works correctly via that substring match; "Only
                       allow..." mode would not truly restrict as advertised, kept for
                       UX consistency with other filter fields. -->
                  <FilterSettingEditor
                    v-model="model.missing_dvir_alert_skip_drivers"
                    fieldKey="missing_dvir_alert_skip_drivers"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="missing_dvir_alert_minutes_to_look_for_dvirs">
                <td class="alert-label">Minutes To Look For DVIRS</td>
                <td>
                  <b-form-input v-model="model.missing_dvir_alert_minutes_to_look_for_dvirs" type="text" :state="numericState('missing_dvir_alert_minutes_to_look_for_dvirs')" @input="validateNumeric('missing_dvir_alert_minutes_to_look_for_dvirs', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('missing_dvir_alert_minutes_to_look_for_dvirs')">{{ numericFeedback('missing_dvir_alert_minutes_to_look_for_dvirs') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="missing_dvir_alert_pre_trip_minutes_after_leaving">
                <td class="alert-label">Pre Trip Minutes After Leaving</td>
                <td>
                  <b-form-input v-model="model.missing_dvir_alert_pre_trip_minutes_after_leaving" type="text" :state="numericState('missing_dvir_alert_pre_trip_minutes_after_leaving')" @input="validateNumeric('missing_dvir_alert_pre_trip_minutes_after_leaving', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('missing_dvir_alert_pre_trip_minutes_after_leaving')">{{ numericFeedback('missing_dvir_alert_pre_trip_minutes_after_leaving') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="missing_dvir_alert_pre_trip_sms_template">
                <td class="alert-label">Pre Trip SMS Template</td>
                <td><PfsRichEditor ref="missingDvirPreTripSmsRef" v-model="model.missing_dvir_alert_pre_trip_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsAlertFields.missingDvir" :editor-ref="$refs.missingDvirPreTripSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr data-field="missing_dvir_alert_post_trip_minutes_after_finish">
                <td class="alert-label">Post Trip Minutes After Finish</td>
                <td>
                  <b-form-input v-model="model.missing_dvir_alert_post_trip_minutes_after_finish" type="text" :state="numericState('missing_dvir_alert_post_trip_minutes_after_finish')" @input="validateNumeric('missing_dvir_alert_post_trip_minutes_after_finish', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('missing_dvir_alert_post_trip_minutes_after_finish')">{{ numericFeedback('missing_dvir_alert_post_trip_minutes_after_finish') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="missing_dvir_alert_post_trip_sms_template">
                <td class="alert-label">Post Trip SMS Template</td>
                <td><PfsRichEditor ref="missingDvirPostTripSmsRef" v-model="model.missing_dvir_alert_post_trip_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsAlertFields.missingDvir" :editor-ref="$refs.missingDvirPostTripSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <b-modal title="Manage HOS Alert Configurations" size="huge" v-model="manage_hos_events" ok-only id="hosModal" @ok="hosModalOk($event)">
      <b> Alert Hour is the hour the alert should send. Only 4 alert events are allowed.</b><br/><br/>
      <div v-if="loading">
        <b-spinner style="width: 2rem; height: 1rem;" label="Loading..."></b-spinner>
      </div>
      <div v-else>
        <b-table v-if="this.hos_alert_event_settings" :items="this.hos_alert_event_settings" :fields="['eventName','eventType','hours','limit','days','phone','email','update','remove']">
          <template slot="update" slot-scope="row">
            <b-button size=" sm" @click="update_hos_event(row.item.eventName)">update</b-button>
            <br/>
          </template>
          <template slot="remove" slot-scope="row">
            <b-button size=" sm" @click="delete_hos_event(row.item.eventName)">remove</b-button>
          </template>
        </b-table>
        <hr/>
        <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mb-2" @click="confirmDefaults('Add the default HOS alert events (Daily Driving Limit, Daily Total HOS Limit)? Events you already have with those names are left alone.', apply_hos_event_defaults, 'Add Default Events')">Add Default Events</b-btn><br/>
        <div style="font-weight: bold; font-size: 18px;" v-on:click="toggle_div(toggle,'isHOSAddEventVisible')">&#43; Add Configuration</div><br/>
        <span :style="toggle.isHOSAddEventVisible ? '' : 'display:none'">
            <div><b>
              Event Name: <b-form-input v-model="add_hos_event_model.eventName" required/>
              Event Type: <b-form-select v-model="add_hos_event_model.eventType" :options="hos_event_options" style="width:200px"></b-form-select><br/>
              Alert Hour: <b-form-input v-model="add_hos_event_model.hours" required :state="numericState('hos_hours')" @input="validateNumeric('hos_hours', $event, 0, 23)"/>
              <b-form-invalid-feedback :state="numericState('hos_hours')">{{ numericFeedback('hos_hours') }}</b-form-invalid-feedback>
              On Duty/Driving Total Limit: <b-form-input v-model="add_hos_event_model.limit" required :state="numericState('hos_limit')" @input="validateNumeric('hos_limit', $event, 0, 168)"/>
              <b-form-invalid-feedback :state="numericState('hos_limit')">{{ numericFeedback('hos_limit') }}</b-form-invalid-feedback>
              Number of Days: <b-form-input v-model="add_hos_event_model.days" required :state="numericState('hos_days')" @input="validateNumeric('hos_days', $event, 1, 30)"/>
              <b-form-invalid-feedback :state="numericState('hos_days')">{{ numericFeedback('hos_days') }}</b-form-invalid-feedback>
              Phone: <b-form-input v-model="add_hos_event_model.phone" />
              Email: <b-form-input v-model="add_hos_event_model.email" />
            </b></div><br/>
            <b-button v-if="!loading" variant="success" size=" sm" @click="add_hos_event()">Save Alert Event</b-button>
          </span>
      </div>
    </b-modal>

    <b-modal title="Manage Booking State Alert Configurations" size="huge" v-model="manage_booking_state_events" ok-only id="booking_state_alert_modal" @ok="bookingStateModalOk($event)">
      <b-table v-if="this.booking_state_alert_settings" :items="this.booking_state_alert_settings" :fields="booking_state_alert_table_fields">
        <template slot="event_types" slot-scope="row">
          <span v-for="(item,idx) in row.item.event_types">
            <span v-if="idx < 3">{{item}}<br/></span>
            <span v-else-if="idx == 3">...</span>
          </span>
        </template>
        <template slot="booking_types" slot-scope="row">
          {{ bookingStateTypeFilterLabel(row.item) }}
        </template>
        <template slot="email_recipients" slot-scope="row">
          <span v-if="row.item.email_recipients">
            <span v-for="item in row.item.email_recipients.split(',')">{{item.trim()}}<br/></span>
          </span>
        </template>
        <template slot="update" slot-scope="row">
          <b-button size="sm" @click="update_booking_state_event(row.item.eventName)">update</b-button>
        </template>
        <template slot="remove" slot-scope="row">
          <b-button size="sm" @click="delete_booking_state_event(row.item.eventName)">remove</b-button>
        </template>
      </b-table>
      <hr/>
      <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mb-2" @click="confirmDefaults('Add the default Booking State alert events and turn Booking State alerts on? Events you already have with those names are left alone.', apply_booking_state_defaults, 'Add Default Events')">Add Default Events</b-btn><br/>
      <div style="font-weight: bold; font-size: 18px;" v-on:click="open_add_booking_state_form()">&#43; Add Configuration</div><br/>
      <span :style="toggle.isBookingStateAddEventVisible ? '' : 'display:none'">
          <div><b>
            Event Name: <b-form-input v-model="add_booking_state_alert_model.eventName" required/>
            <br/>
            Event Types: <b-form-checkbox-group v-model="add_booking_state_alert_model.event_types" :options="booking_state_alert_options_computed"></b-form-checkbox-group>
            <small style="color: #888;">Invalid Actuals is a post-trip check and must be configured separately.</small>
            <br/>
            <span v-if="(add_booking_state_alert_model.event_types || []).some(t => t !== 'Invalid Actuals')">
            Hours Before Departure: <b-form-input v-model="add_booking_state_alert_model.hrs_before" :state="numericState('bsa_hrs_before')" @input="validateNumeric('bsa_hrs_before', $event, 0, 168)"></b-form-input>
            <b-form-invalid-feedback :state="numericState('bsa_hrs_before')">{{ numericFeedback('bsa_hrs_before') }}</b-form-invalid-feedback>
            </span>
            <span v-if="(add_booking_state_alert_model.event_types || []).includes('Invalid Actuals')">
            Hours After Last Arrival: <b-form-input v-model="add_booking_state_alert_model.hrs_after" :state="numericState('bsa_hrs_after')" @input="validateNumeric('bsa_hrs_after', $event, 0, 48)"></b-form-input>
            <b-form-invalid-feedback :state="numericState('bsa_hrs_after')">{{ numericFeedback('bsa_hrs_after') }}</b-form-invalid-feedback>
            </span>
            <br/>
            Check Every (hrs): <b-form-select v-model="add_booking_state_alert_model.poll_interval_hrs" :options="[{value:'1',text:'1 hr'},{value:'2',text:'2 hrs'},{value:'3',text:'3 hrs'},{value:'4',text:'4 hrs'},{value:'6',text:'6 hrs'},{value:'8',text:'8 hrs'},{value:'12',text:'12 hrs'},{value:'24',text:'24 hrs'}]" style="width:120px"></b-form-select>
            <br/>
            <span v-if="tenant_type == 'TBN'">
            Bookings Enabled: <b-form-select v-model="add_booking_state_alert_model.private_hires_enabled" :options="boolean_options"/>
            Scheduled Services Enabled: <b-form-select v-model="add_booking_state_alert_model.contracts_enabled" :options="boolean_options"/>
            School Bus Enabled: <b-form-select v-model="add_booking_state_alert_model.school_contracts_enabled" :options="boolean_options"/>
            </span>
            <span v-if="tenant_type == 'CM'">
            Contracts Enabled: <b-form-select v-model="add_booking_state_alert_model.contracts_enabled" :options="boolean_options"/>
            Private Hires Enabled: <b-form-select v-model="add_booking_state_alert_model.private_hires_enabled" :options="boolean_options"/>
            </span>
            <br/>
            Email Recipients: <b-form-input v-model="add_booking_state_alert_model.email_recipients" />
          </b></div><br/>
          <div style="color:red; font-weight:bold;" v-if='this.error_msg !=""'>
            <b>{{this.error_msg}}</b><br/>
          </div>
          <b-button v-if="!loading" variant="success" size="sm" @click="add_booking_state_event()">Save</b-button>
      </span>
    </b-modal>

    <b-modal title="Manage Vehicle Late Alert Configurations" size="huge" v-model="manage_vehicle_late_events" ok-only id="vehicle_late_alert_modal" @ok="vehicleLateModalOk($event)">
      <b-table v-if="this.vehicle_late_alert_settings" :items="this.vehicle_late_alert_settings" :fields="['eventName','event_types','minutes_threshold','send_to_driver','sms_recipients','voice_recipients','email_recipients','update','duplicate','remove']">
        <template slot="event_types" slot-scope="row">
          <span v-for="(item,idx) in row.item.event_types">
            <span v-if="idx < 2">{{item}}<br/></span>
            <span v-else-if="idx == 2">...</span>
          </span>
        </template>
        <template slot="sms_recipients" slot-scope="row">
          <span v-if="row.item.sms_recipients">
            <span v-for="(item,idx) in row.item.sms_recipients.split(',')">
              <span v-if="idx < 2">{{item}}<br/></span>
              <span v-else-if="idx == 2">...</span>
            </span>
          </span>
        </template>
        <template slot="email_recipients" slot-scope="row">
          <span v-if="row.item.email_recipients">
            <span v-for="item in row.item.email_recipients.split(',')">{{item.trim()}}<br/></span>
          </span>
        </template>
        <template slot="voice_recipients" slot-scope="row">
          <span v-if="row.item.voice_recipients">
            <span v-for="item in row.item.voice_recipients.split(',')">{{item.trim()}}<br/></span>
          </span>
        </template>
        <template slot="update" slot-scope="row">
          <b-button size="sm" @click="update_vehicle_late_event(row.item.eventName)">update</b-button>
          <br/>
        </template>
        <template slot="duplicate" slot-scope="row">
          <b-button size="sm" @click="duplicate_vehicle_late_event(row.item.eventName)">duplicate</b-button>
        </template>
        <template slot="remove" slot-scope="row">
          <b-button size="sm" @click="delete_vehicle_late_event(row.item.eventName)">remove</b-button>
        </template>
      </b-table>
      <hr/>
      <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mb-2" @click="confirmDefaults('Add the default Vehicle Late alert events? Events you already have with those names are left alone.', apply_vehicle_late_alert_defaults, 'Add Default Events')">Add Default Events</b-btn><br/>
      <div ref="LateAlertModal" style="font-weight: bold; font-size: 18px;" v-on:click="toggle_div(toggle,'isVehicleLateAddEventVisible')">{{ editing_vehicle_late_event_name ? 'Edit Configuration' : '+ Add Configuration' }}</div><br/>
      <span :style="toggle.isVehicleLateAddEventVisible ? '' : 'display:none'">
          <div><b>
            Event Name: <b-form-input v-model="add_vehicle_late_alert_model.eventName" required/>
            <br/>
            Events Types:
            <div style="margin-top: 4px; display: flex; flex-wrap: wrap; align-items: flex-start; gap: 4px 0;">
              <template v-for="(group, groupIdx) in vehicle_late_alert_groups">
                <div v-if="groupIdx > 0" style="border-left: 1px solid #ccc; margin: 0 10px; align-self: stretch;"></div>
                <div style="display: flex; flex-direction: row; gap: 0 12px;">
                  <div v-if="group.columns" v-for="col in group.columns" style="display: flex; flex-direction: column;">
                    <b-form-checkbox
                      v-for="item in col"
                      :key="item"
                      v-model="add_vehicle_late_alert_model.event_types"
                      :value="item"
                      :disabled="isEventTypeDisabled(item)"
                    >{{ item }}</b-form-checkbox>
                  </div>
                  <div v-if="group.items" style="display: flex; flex-direction: column;">
                    <b-form-checkbox
                      v-for="item in group.items"
                      :key="item"
                      v-model="add_vehicle_late_alert_model.event_types"
                      :value="item"
                      :disabled="isEventTypeDisabled(item)"
                    >{{ item }}</b-form-checkbox>
                  </div>
                </div>
              </template>
            </div>
            <br/>
            Minutes Threshold: <b-form-input v-model="add_vehicle_late_alert_model.minutes_threshold" :state="numericState('vla_minutes_threshold')" @input="validateNumeric('vla_minutes_threshold', $event, -60, 1440)"></b-form-input>
            <b-form-invalid-feedback :state="numericState('vla_minutes_threshold')">{{ numericFeedback('vla_minutes_threshold') }}</b-form-invalid-feedback>
            Distance Threshold:<b-form-input v-model="add_vehicle_late_alert_model.distance_threshold" :disabled=!isEnabled(add_vehicle_late_alert_model) :state="numericState('vla_distance_threshold')" @input="validateNumeric('vla_distance_threshold', $event, 0, 1000)"></b-form-input>
            <b-form-invalid-feedback :state="numericState('vla_distance_threshold')">{{ numericFeedback('vla_distance_threshold') }}</b-form-invalid-feedback>
            <span v-if="tenant_type == 'TBN'">
            Use Driver Start Time: <b-form-select v-model="add_vehicle_late_alert_model.driver_start" :options="boolean_options"/>
            Use First Departure Time: <b-form-select v-model="add_vehicle_late_alert_model.departure"  :options="boolean_options"/>
            </span>
            Minutes Before Start Time To Look For Data: <b-form-input v-model="add_vehicle_late_alert_model.minutes_before" :state="numericState('vla_minutes_before')" @input="validateNumeric('vla_minutes_before', $event, 0, 1440)"></b-form-input>
            <b-form-invalid-feedback :state="numericState('vla_minutes_before')">{{ numericFeedback('vla_minutes_before') }}</b-form-invalid-feedback>
            <span v-if="isNeverAtYardEnabled(add_vehicle_late_alert_model)">
            Suppress If Vehicle Never At Yard:
            <i class="fa fa-info-circle tc-field-info"
               v-b-tooltip.hover.right="'If the vehicle was never seen at the scheduled start location before its scheduled departure, don\'t send a \'vehicle not left\' alert - it likely never returned to the yard rather than failing to depart on time.'"
               tabindex="0"
               aria-label="What does this field do?"></i>
            <b-form-select v-model="add_vehicle_late_alert_model.suppress_if_never_at_yard" :options="boolean_options"/>
            <span v-if="add_vehicle_late_alert_model.suppress_if_never_at_yard == 'True'">
            Hours Before Start Time To Look For Vehicle In Yard:
            <i class="fa fa-info-circle tc-field-info"
               v-b-tooltip.hover.right="'How far back to look for the vehicle at the yard before deciding it was never there. Defaults to 1 hour if left blank.'"
               tabindex="0"
               aria-label="What does this field do?"></i>
            <b-form-input v-model="add_vehicle_late_alert_model.suppress_if_never_at_yard_lookback_hours" placeholder="1" :state="numericState('vla_never_at_yard_lookback_hours')" @input="validateNumeric('vla_never_at_yard_lookback_hours', $event, 0, 168)"></b-form-input>
            <b-form-invalid-feedback :state="numericState('vla_never_at_yard_lookback_hours')">{{ numericFeedback('vla_never_at_yard_lookback_hours') }}</b-form-invalid-feedback>
            </span>
            </span>
            Time Window: <b-form-input v-model="add_vehicle_late_alert_model.time_window"></b-form-input>
            SMS Template: <PfsRichEditor ref="vehicleLateAlertModalSmsRef" v-model="add_vehicle_late_alert_model.sms_template" style="max-width: 800px"/>
            <PfsFieldHelp :fields="pfsAlertFields.vehicleLateAlert" :editor-ref="$refs.vehicleLateAlertModalSmsRef" :tenant-type="tenant_type" />
            Send To Driver: <b-form-select v-model="add_vehicle_late_alert_model.send_to_driver" :options="boolean_options"/>
            SMS Recipients: <b-form-input v-model="add_vehicle_late_alert_model.sms_recipients" />
            Voice Call Recipients: <b-form-input v-model="add_vehicle_late_alert_model.voice_recipients" />
            Voice Message: <b-form-input v-model="add_vehicle_late_alert_model.voice_message" />
            Voice Time Window: <b-form-input v-model="add_vehicle_late_alert_model.voice_time_window" />
            Email Recipients: <b-form-input v-model="add_vehicle_late_alert_model.email_recipients" />
            Email Subject: <PfsRichEditor ref="vehicleLateAlertModalEmailSubjectRef" v-model="add_vehicle_late_alert_model.email_subject" style="max-width: 800px"/>
            <PfsFieldHelp :fields="pfsAlertFields.vehicleLateAlert" :editor-ref="$refs.vehicleLateAlertModalEmailSubjectRef" :tenant-type="tenant_type" />

            <span v-if="tenant_type != 'TBN'">
              Slack URL: <b-form-input v-model="add_vehicle_late_alert_model.slack_url" />
              MS Teams URL: <b-form-input v-model="add_vehicle_late_alert_model.msteams_url" />
            </span>

            <div style="margin:5px; color: var(--fi-rail-accent); font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'showAdvLateAlertFilters')">&#43; Show Filters</div>
            <div v-if="toggle.showAdvLateAlertFilters" style="margin-left:10px; padding: 10px; border: 1px solid black">
              Contracts Enabled: <b-form-select v-model="add_vehicle_late_alert_model.contracts_enabled" :options="boolean_options"/>
              Charters Enabled: <b-form-select v-model="add_vehicle_late_alert_model.private_hires_enabled" :options="boolean_options"/>
              Driver Name Filter:
              <FilterSettingEditor v-model="add_vehicle_late_alert_model.driver_name_filter" fieldKey="adv_late_driver_name_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Driver Tag Filter:
              <FilterSettingEditor v-model="add_vehicle_late_alert_model.driver_tag_filter" fieldKey="adv_late_driver_tag_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Vehicle Tag Filter:
              <FilterSettingEditor v-model="add_vehicle_late_alert_model.vehicle_tag_filter" fieldKey="adv_late_vehicle_tag_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Booking Base Filter:
              <FilterSettingEditor v-model="add_vehicle_late_alert_model.booking_base_filter" fieldKey="adv_late_booking_base_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Route Description Filter:
              <FilterSettingEditor v-model="add_vehicle_late_alert_model.route_description_filter" fieldKey="adv_late_route_description_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Movement Start Base Filter:
              <FilterSettingEditor v-model="add_vehicle_late_alert_model.movement_start_base_filter" fieldKey="adv_late_movement_start_base_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Company ID Filter:
              <FilterSettingEditor v-model="add_vehicle_late_alert_model.company_id_filter" fieldKey="adv_late_company_id_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Client ID Filter:
              <FilterSettingEditor v-model="add_vehicle_late_alert_model.client_id_filter" fieldKey="adv_late_client_id_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
            </div>
          </b></div><br/>
          <div style="color:red; font-weight:bold;" v-if='this.error_msg !="" '>
            <b>{{this.error_msg}}</b><br/>
          </div>
          <b-button v-if="!loading" variant="success" size="sm" @click="add_vehicle_late_event()">{{ editing_vehicle_late_event_name ? 'Update' : 'Save' }}</b-button>
          <b-button v-if="editing_vehicle_late_event_name && !loading" variant="secondary" size="sm" class="ml-1" @click="cancel_edit_vehicle_late_event()">Cancel</b-button>
        </span>
    </b-modal>

    <div class="tc-sticky-save">
      <transition name="tc-save-slide">
      <div v-if="isDirty || saving" class="d-flex align-items-center justify-content-center">
        <span v-if="isDirty && !saving" class="tc-unsaved-label mr-3" @click="scrollToFirstDirtyField()" title="Click to scroll to unsaved field" style="cursor:pointer">&#9679; Unsaved changes</span>
        <b-btn size="lg" variant="success" @click="save_config" :disabled="saving">
          <b-spinner v-if="saving" small class="mr-1"></b-spinner>
          {{ saving ? 'Saving...' : 'Save' }}
        </b-btn>
        &nbsp;&nbsp;
        <b-btn size="lg" variant="secondary" @click="load_data(true)">Discard Changes</b-btn>
      </div>
      </transition>
    </div>
  </div>

</template>
<script>
import {add_hos_event, add_vehicle_late_alert_event, delete_hos_event, delete_vehicle_late_alert_event, add_booking_state_alert_event, delete_booking_state_alert_event, get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import {mapState} from "vuex";
import numericValidationMixin from '../mixins/numeric_validation_mixin'
import filterValidationMixin from '../mixins/filter_validation_mixin'
import jsonValidationMixin from '../mixins/json_validation_mixin'
import dirtyTrackingMixin from '../mixins/dirty_tracking_mixin'
import confirmDefaultsMixin from '../mixins/confirm_defaults_mixin'
import JsonObjectListEditor from './JsonObjectListEditor.vue'
import PfsRichEditor from './PfsRichEditor.vue'
import PfsFieldHelp from './PfsFieldHelp.vue'
import FilterSettingEditor from './FilterSettingEditor.vue'
import { ensureFilterKeys } from '../utils/filter_syntax'
import { LATE_ALERT_FIELDS, LATE_ALERT_VOICE_FIELDS, VEHICLE_LATE_ALERT_FIELDS, VEHICLE_INACTIVITY_FIELDS, DRIVER_HOS_FIELDS, UNPLANNED_VEHICLE_ACTIVITY_FIELDS, GATEWAY_DISCONNECT_FIELDS, MISSING_DVIR_FIELDS, ELD_IDLE_FIELDS, ELD_GEOFENCE_FIELDS, ELD_FAULT_FIELDS } from '../utils/pfs_fields'

const VEHICLE_LATE_ALERT_MODAL_FILTER_KEYS = [
  'driver_name_filter',
  'driver_tag_filter',
  'vehicle_tag_filter',
  'booking_base_filter',
  'route_description_filter',
  'movement_start_base_filter',
  'company_id_filter',
  'client_id_filter',
]

const TBN_DEFAULT_VEHICLE_LATE_ALERT_SETTINGS = [
  {
    driver_start: 'True',
    eventName: 'Driver HOS Alert',
    event_types: ['No Driver HOS Login'],
    minutes_threshold: '5',
    send_to_driver: 'False',
    sms_template: 'Driver Late Alert: [driverName] [driverNumber]\nVehicle: [vehicleID] \nBooking: [charterID]\nStart: [startTime]\nSpot: [spotTime]\nPickup: [pickupTime]\nLocation: [pickupLocation]\nIf you are on site, please sign into your assigned vehicle',
  },
  {
    driver_start: 'True',
    eventName: 'Driver HOS Alert - Escalated',
    event_types: ['No Driver HOS Login'],
    minutes_threshold: '15',
    send_to_driver: 'False',
    sms_recipients: '',
    sms_template: 'Escalated Driver Late Alert: [driverName] [driverNumber]\nVehicle: [vehicleID] \nBooking: [charterID]\nStart: [startTime]\nSpot: [spotTime]\nPickup: [pickupTime]\nLocation: [pickupLocation]',
  },
  {
    departure: 'True',
    email_recipients: '',
    eventName: 'Vehicle Not Departed',
    event_types: ['Vehicle Not Left'],
    minutes_threshold: '5',
    send_to_driver: 'False',
    sms_recipients: '',
    sms_template: 'Vehicle Departure Alert: [driverName] [driverNumber]\nVehicle: [vehicleID] \nBooking: [charterID]\nStart: [startTime]\nSpot: [spotTime]\nPickup: [pickupTime]\nLocation: [pickupLocation]',
  },
]

const CM_DEFAULT_VEHICLE_LATE_ALERT_SETTINGS = [
  {
    eventName: 'Driver HOS Alert',
    event_types: ['No Driver HOS Login'],
    minutes_threshold: '5',
    send_to_driver: 'False',
    sms_template: 'Driver Late Alert: [driverName] [driverNumber]\nVehicle: [vehicleID] \nBooking: [charterID]\nStart: [startTime]\nSpot: [spotTime]\nPickup: [pickupTime]\nLocation: [pickupLocation]\nIf you are on site, please sign into your assigned vehicle',
  },
  {
    eventName: 'Driver HOS Alert - Escalated',
    event_types: ['No Driver HOS Login'],
    minutes_threshold: '15',
    send_to_driver: 'False',
    sms_recipients: '',
    sms_template: 'Escalated Driver Late Alert: [driverName] [driverNumber]\nVehicle: [vehicleID] \nBooking: [charterID]\nStart: [startTime]\nSpot: [spotTime]\nPickup: [pickupTime]\nLocation: [pickupLocation]',
  },
  {
    email_recipients: '',
    eventName: 'Vehicle Not Departed',
    event_types: ['Vehicle Not Left'],
    minutes_threshold: '5',
    send_to_driver: 'False',
    sms_recipients: '',
    sms_template: 'Vehicle Departure Alert: [driverName] [driverNumber]\nVehicle: [vehicleID] \nBooking: [charterID]\nStart: [startTime]\nSpot: [spotTime]\nPickup: [pickupTime]\nLocation: [pickupLocation]',
  },
]

const DEFAULT_VEHICLE_LATE_ALERT_SETTINGS_BY_TENANT_TYPE = {
  TBN: TBN_DEFAULT_VEHICLE_LATE_ALERT_SETTINGS,
  CM: CM_DEFAULT_VEHICLE_LATE_ALERT_SETTINGS,
}

// Plain-text PFS template fields must never be JSON-parsed, matching the backend
function isPfsTemplateField(key) {
  return key.includes('_template') || key.endsWith('_email_subject') || key.endsWith('_voice_message')
}

export default {
  name: 'tenant_config',
  mixins: [numericValidationMixin, filterValidationMixin, jsonValidationMixin, dirtyTrackingMixin, confirmDefaultsMixin],
  components: {
    JsonObjectListEditor,
    PfsRichEditor,
    PfsFieldHelp,
    FilterSettingEditor,
  },

  data() {
    return {
      add_hos_event_model: {},
      manage_hos_events: false,
      hos_alert_event_settings: [],
      add_vehicle_late_alert_model: this._default_vehicle_late_alert_model(),
      editing_vehicle_late_event_name: null,
      manage_vehicle_late_events: false,
      vehicle_late_alert_settings: [],
      add_booking_state_alert_model: {},
      manage_booking_state_events: false,
      booking_state_alert_settings: [],
      booking_state_alert_options: [],
      error_msg: "",
      model: {},
      tenant_json: {},
      pfsAlertFields: {
        lateAlert: LATE_ALERT_FIELDS,
        lateAlertVoice: LATE_ALERT_VOICE_FIELDS,
        vehicleLateAlert: VEHICLE_LATE_ALERT_FIELDS,
        vehicleInactivity: VEHICLE_INACTIVITY_FIELDS,
        driverHos: DRIVER_HOS_FIELDS,
        unplannedVehicle: UNPLANNED_VEHICLE_ACTIVITY_FIELDS,
        gatewayDisconnect: GATEWAY_DISCONNECT_FIELDS,
        missingDvir: MISSING_DVIR_FIELDS,
        eldIdle: ELD_IDLE_FIELDS,
        eldGeofence: ELD_GEOFENCE_FIELDS,
        eldFault: ELD_FAULT_FIELDS,
      },
      toggle: {
        isLateAlertVisible: false,
        isVehActivityVisible: false,
        isVehInactiveVisible: false,
        isHOSDurationVisible: false,
        isUnplannVisible: false,
        isGatewayDisconnectVisible: false,
        isMissingDVIRVisible: false,
        isHOSAddEventVisible: false,
        isBookingStateAddEventVisible: false,
        isVehicleLateAddEventVisible: false,
        showAdvLateAlertFilters: false,
      },
      summary: {},
      loading: true,
      selectedYardOptions: [],
      selectedEventOptions: [],
      yard_options: [],
      objectKeyList: [],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
      hos_event_options: [
        { text: 'Total', value: 'total' },
        { text: 'Driving', value: 'driving' },
        { text: 'On Duty', value: 'onduty' },
      ],
      vehicle_late_alert_groups: [],
      fieldPrefixSectionMap: [
        ['late_alert_', 'isLateAlertVisible'],
        ['eld_alert_', 'isVehActivityVisible'],
        ['vehicle_inactivity_alert_', 'isVehInactiveVisible'],
        ['driver_hos_alerts_', 'isHOSDurationVisible'],
        ['unplanned_vehicle_activity_alert_', 'isUnplannVisible'],
        ['gateway_disconnect_alert_', 'isGatewayDisconnectVisible'],
        ['missing_dvir_alert_', 'isMissingDVIRVisible'],
      ],
      jsonFieldToggleMap: {
        late_alert_voice_base_config: 'isLateAlertVisible',
      },
      voice_base_config_columns: [
        { key: 'base', label: 'Booking Base', type: 'text', placeholder: 'e.g. Main' },
        { key: 'phone', label: 'Phone Number', type: 'text', placeholder: 'e.g. 16195551234' },
      ],
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    _default_vehicle_late_alert_model() {
      // Vue 2 only reacts to keys present on an object at creation time - the
      // suppress_if_never_at_yard toggle (and its lookback-hours input) must be seeded
      // here up front, or the nested v-if reading them silently never reacts (FI-1976).
      return {
        event_types: [],
        suppress_if_never_at_yard: null,
        suppress_if_never_at_yard_lookback_hours: null,
      }
    },
    _sync_model_settings(key, array) {
      const json = JSON.stringify(array)
      this.model[key] = json
      if (this.modelSnapshot) {
        const snap = JSON.parse(this.modelSnapshot)
        snap[key] = json
        this.modelSnapshot = JSON.stringify(snap)
      }
    },
    apply_eld_alert_defaults() {
      Object.assign(this.model, {
        eld_alert_enabled: 'True',
        eld_alert_send_to_driver: 'False',
        eld_alert_idle_alert_sms_template: '[vehicleID] has been idling for [idleMinutes]+ minutes',
        eld_alert_idle_alert_sms_geofence_template: '[vehicleID] idle alert (geofence): [vehicleID]',
        eld_alert_fault_alert_sms_template: '[vehicleID] has a vehicle fault: [faultDescription]',
      })
      this.$bvToast.toast('Vehicle activity alert defaults applied — add recipients and configure fault mappings to complete setup.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    apply_vehicle_inactivity_defaults() {
      Object.assign(this.model, {
        vehicle_inactivity_alert_enabled: 'True',
        vehicle_inactivity_alert_send_to_driver: 'False',
        vehicle_inactivity_alert_duration_threshold: '30',
        vehicle_inactivity_alert_speed_threshold: '5',
        vehicle_inactivity_alert_active_time_windows: '06:00-22:00',
        vehicle_inactivity_alert_sms_template: '[vehicleID] has been inactive for [duration] minutes',
      })
      this.$bvToast.toast('Vehicle inactivity defaults applied — add recipients and save to confirm.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    apply_hos_alert_defaults() {
      Object.assign(this.model, {
        driver_hos_alerts_enabled: 'True',
        driver_hos_alerts_send_to_driver: 'False',
        driver_hos_alerts_sms_template: '[driverFirstName] [driverLastName] - HOS [eventType] limit of [hourLimit]hrs exceeded ([onDutyOrDrivingHours]hrs logged)',
      })
      this.$bvToast.toast('HOS alert defaults applied — add recipients, alert events, and save to confirm.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    async apply_hos_event_defaults() {
      const defaults = [
        { eventName: 'Daily Driving Limit', eventType: 'driving', hours: '8', limit: '8', days: '1', phone: '', email: '' },
        { eventName: 'Daily Total HOS Limit', eventType: 'total', hours: '10', limit: '10', days: '1', phone: '', email: '' },
      ]
      const existing_names = this.hos_alert_event_settings.map(e => e.eventName)
      for (const event of defaults) {
        if (!existing_names.includes(event.eventName)) {
          await add_hos_event(this.user.tenant, event)
          this.hos_alert_event_settings.push(event)
        }
      }
      this._sync_model_settings('driver_hos_alerts_settings', this.hos_alert_event_settings)
      this.$bvToast.toast('Default HOS events added — add recipients to each event to complete setup.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    apply_unplanned_activity_defaults() {
      Object.assign(this.model, {
        unplanned_vehicle_activity_alert_enabled: 'True',
        unplanned_vehicle_activity_alert_yard_mile_radius: '1',
        unplanned_vehicle_activity_alert_sms_template: '[vehicleID] - unplanned activity detected outside yard',
      })
      this.$bvToast.toast('Unplanned activity defaults applied — add recipients and save to confirm.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    async apply_vehicle_late_alert_defaults() {
      const existing_names = this.vehicle_late_alert_settings.map(e => e.eventName)
      try {
        for (const event of this._default_vehicle_late_alert_events()) {
          if (!existing_names.includes(event.eventName)) {
            // existing_names is a snapshot from page load, so it can still collide
            // (another tab/user added a same-named event since) and the API-side
            // rename guard will 400. Surface that instead of leaving the loop to die
            // on an unhandled rejection with no toast and no error text.
            await add_vehicle_late_alert_event(this.user.tenant, event)
            this.vehicle_late_alert_settings.push(event)
          }
        }
        this.$bvToast.toast('Default events added — add recipients to each event to complete setup.', { variant: 'success', autoHideDelay: 4000, solid: true, noCloseButton: true })
      } catch (e) {
        const message = (e.response && e.response.data && e.response.data.message) || 'Error adding default events, try logging in again or contact support if needed'
        this.$bvToast.toast(message, { variant: 'danger', autoHideDelay: 5000, solid: true, noCloseButton: true })
      }
    },
    async apply_booking_state_defaults() {
      const type_filters = {
        private_hires_enabled: 'True',
        contracts_enabled: 'True',
      }
      if (this.tenant_type === 'TBN') {
        type_filters.school_contracts_enabled = 'True'
      }
      const defaults = [
        {
          eventName: 'Missing Driver',
          event_types: ['Missing Driver'],
          hrs_before: '24',
          hrs_after: '0',
          poll_interval_hrs: '2',
          email_recipients: '',
          ...type_filters,
        },
        {
          eventName: 'Missing Vehicle',
          event_types: ['Missing Vehicle'],
          hrs_before: '24',
          hrs_after: '0',
          poll_interval_hrs: '2',
          email_recipients: '',
          ...type_filters,
        },
        {
          eventName: 'Invalid Actuals',
          event_types: ['Invalid Actuals'],
          hrs_before: '0',
          hrs_after: '48',
          poll_interval_hrs: '4',
          email_recipients: '',
          ...type_filters,
        },
      ]
      this.model.booking_state_alert_enabled = 'True'
      const existing_names = this.booking_state_alert_settings.map(e => e.eventName)
      for (const event of defaults) {
        if (!existing_names.includes(event.eventName)) {
          await add_booking_state_alert_event(this.user.tenant, event)
          this.booking_state_alert_settings.push(event)
        }
      }
      this._sync_model_settings('booking_state_alert_settings', this.booking_state_alert_settings)
      this.$bvToast.toast('Default events added — add recipients to each event to complete setup.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    apply_gateway_disconnect_defaults() {
      Object.assign(this.model, {
        gateway_disconnect_alert_enabled: 'True',
        gateway_disconnect_alert_threshold_minutes: '10',
        gateway_disconnect_alert_grace_period_minutes: '10',
        gateway_disconnect_alert_send_to_driver: 'False',
      })
      this.$bvToast.toast('Gateway disconnect defaults applied — add recipients and save to confirm.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    apply_missing_dvir_defaults() {
      Object.assign(this.model, {
        missing_dvir_alert_enabled: 'True',
        missing_dvir_alert_pre_trip_enabled: 'True',
        missing_dvir_alert_post_trip_enabled: 'True',
        missing_dvir_alert_pre_trip_minutes_after_leaving: '15',
        missing_dvir_alert_post_trip_minutes_after_finish: '15',
        missing_dvir_alert_minutes_to_look_for_dvirs: '240',
        missing_dvir_alert_send_to_driver: 'False',
        missing_dvir_alert_test_mode: 'False',
        missing_dvir_alert_pre_trip_sms_template: 'Missing Pre-Trip DVIR: [driverName] - Vehicle [vehicleID] - Start [startTime] at [startLocation]',
        missing_dvir_alert_post_trip_sms_template: 'Missing Post-Trip DVIR: [driverName] - Vehicle [vehicleID] - Finish [finishTime] at [finishLocation]',
      })
      this.$bvToast.toast('Missing DVIR defaults applied — add recipients and save to confirm.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    _default_vehicle_late_alert_events() {
      if (this.tenant_type === 'CM') return CM_DEFAULT_VEHICLE_LATE_ALERT_SETTINGS
      if (this.tenant_type === 'TBN') return TBN_DEFAULT_VEHICLE_LATE_ALERT_SETTINGS
      if (this.tenant_type === 'FASTTRAK') {
        return [
          { eventName: 'Vehicle Not Left', event_types: ['Vehicle Not Left'], minutes_threshold: '5', send_to_driver: 'False', sms_template: 'Vehicle Departure Alert: [driverName]\nVehicle: [vehicleID]\nBooking: [charterID]\nScheduled: [scheduledTime]' },
          { eventName: 'Est Late To Pickup', event_types: ['Vehicle Est Late To Pickup'], minutes_threshold: '0', send_to_driver: 'False', sms_template: '[vehicleID] is estimated to be late to pickup' },
        ]
      }
      return []
    },

    async load_data(silent = false) {
      if (!silent) this.loading = true
      this.objectKeyList = []
      this.error_msg = ""
      let loaded = false
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results
        ensureFilterKeys(this.model, [
          'late_alert_booking_type_filter',
          'late_alert_booking_id_filter',
          'late_alert_client_id_filter',
          'late_alert_driver_tag_filter',
          'late_alert_vehicle_tag_filter',
          'late_alert_vehicle_filter',
          'vehicle_inactivity_alert_vehicle_filter',
          'vehicle_inactivity_alert_vehicle_tag_filter',
          'unplanned_vehicle_activity_alert_vehicle_filter',
          'missing_dvir_alert_vehicle_tag_filter',
          'missing_dvir_alert_skip_drivers',
        ])
        this.tenant_json = data.summary.tenant
        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value, key) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }

        this.add_vehicle_late_alert_model = this._default_vehicle_late_alert_model()
        ensureFilterKeys(this.add_vehicle_late_alert_model, VEHICLE_LATE_ALERT_MODAL_FILTER_KEYS)
        if (this.tenant_type == 'CM') {
          this.vehicle_late_alert_groups = [
            { columns: [['No Driver HOS Login', 'No Driver DVIR', 'Vehicle Not Started'], ['Vehicle Not Moved', 'Vehicle Not Left']] },
            { items: ['Vehicle Not Near Spot'] },
            { items: ['Vehicle Est Late To Pickup'] },
            { items: ['Vehicle Not Ready'] },
          ]
        }
        else if (this.tenant_type == 'FASTTRAK') {
          this.vehicle_late_alert_groups = [
            { items: ['Vehicle Not Left'] },
            { items: ['Vehicle Est Late To Pickup'] },
            { items: ['Vehicle Not Ready'] },
          ]
        } else {
          this.vehicle_late_alert_groups = [
            { columns: [['No Driver HOS Login', 'No TBN Driver Login', 'No Driver DVIR'], ['Vehicle Not Started', 'Vehicle Not Moved', 'Vehicle Not Left']] },
            { items: ['Vehicle Not Ready'] },
          ]
        }

        try {
          if (this.model.driver_hos_alerts_settings != "" && this.model.driver_hos_alerts_settings != null) {
            this.hos_alert_event_settings = JSON.parse(this.model.driver_hos_alerts_settings);
          } else {
            this.hos_alert_event_settings = []
          }
        } catch(e) {
          console.log('exception converting hos alert settings to json:' + e)
        }

        try {
          if (this.model.vehicle_late_alert_settings != null && this.model.vehicle_late_alert_settings != "") {
            this.vehicle_late_alert_settings = JSON.parse(this.model.vehicle_late_alert_settings);
          } else {
            this.vehicle_late_alert_settings = []
          }
        } catch(e) {
          console.log('exception converting vehicle late alert settings to json:', e)
        }

        this.add_booking_state_alert_model = this._default_booking_state_alert_model()
        this.booking_state_alert_options = [
          { value: 'Missing Driver',    text: 'Missing Driver' },
          { value: 'Missing Vehicle',   text: 'Missing Vehicle' },
          { value: 'Invalid Times',     text: 'Invalid Times' },
          { value: 'Invalid Locations', text: 'Invalid Locations' },
          { value: 'Invalid Actuals',   text: 'Invalid Actuals' },
        ]

        try {
          if (this.model.booking_state_alert_settings != null && this.model.booking_state_alert_settings != "") {
            this.booking_state_alert_settings = JSON.parse(this.model.booking_state_alert_settings);
          } else {
            this.booking_state_alert_settings = []
          }
        } catch(e) {
          console.log('exception converting booking state alert settings to json:', e)
        }

        try {
          if (this.model.late_alert_yards != null && this.model.late_alert_yards != "") {
            this.selectedYardOptions = this.model.late_alert_yards.split(",")
          } else {
            this.selectedYardOptions = []
          }
          if (this.model.vehicle_yards != null && this.model.vehicle_yards != "") {
            this.model.vehicle_yards = JSON.parse(this.model.vehicle_yards);
            let options = []
            for (const item of this.model.vehicle_yards) {
              let yard = { text: item.yard_name, value: item.yard_name }
              options.push(yard)
            }
            this.yard_options = options
          }
        } catch(e) {
          console.log('error setting up vehicle yards for late alerts',e)
        }
        loaded = true
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this._prev_gateway_disconnect_enabled = this.model.gateway_disconnect_alert_enabled
      this.loading = false
      if (loaded) this._resetDirtyTracking()
    },
    async save_config() {
      try {
        this.saving = true
        this.flushNumericValidation()
        this.flushFilterValidation()
        if (this.hasNumericErrors()) {
          this.$emit('showAlert', 'Fix the highlighted field before saving', 'danger', 6000)
          this.scrollToFirstNumericError()
          return
        }
        if (this.hasFilterErrors()) {
          this.$emit('showAlert', 'Fix the highlighted filter field before saving', 'danger', 6000)
          this.scrollToFirstFilterError()
          return
        }
        if (this.hasJsonErrors()) {
          this.$emit('showAlert', 'Invalid JSON in field: ' + this.firstJsonErrorKey() + ' — ' + this.jsonFeedback(this.firstJsonErrorKey()), 'danger', 8000)
          this.expandAndScrollToJsonError()
          return
        }
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        const was_gw_disconnect_off = this._prev_gateway_disconnect_enabled !== 'True'
        this.setup_yards_to_save()

        // Compute dirty keys before parsing (model still holds JSON strings matching snapshot).
        const dirtyKeys = new Set(Object.keys(this._dirtyFields()))
        const fullPayload = Object.assign({}, this.model)
        for (const objkey of this.objectKeyList) {
          try {
            if (fullPayload[objkey] && fullPayload[objkey].trim && fullPayload[objkey].trim() !== '') {
              fullPayload[objkey] = JSON.parse(fullPayload[objkey])
            }
          } catch (e) {
            this.$emit('showAlert', 'Invalid JSON in field: ' + objkey + ' — ' + e.message, 'danger', 8000)
            this.expandAndScrollToJsonError()
            await this.load_data()
            return
          }
        }
        const payload = {}
        for (const key of dirtyKeys) {
          if (key in fullPayload) payload[key] = fullPayload[key]
        }
        await update_tenant_config_settings(this.user.tenant, payload)
        await this._resetDirtyTracking()
        await this.load_data(true)

        if (was_gw_disconnect_off && this.model.gateway_disconnect_alert_enabled === 'True' && (!this.model.vehicle_yards || (Array.isArray(this.model.vehicle_yards) && this.model.vehicle_yards.length === 0))) {
          this.$emit('showAlert', 'Configuration Saved — Warning: Gateway disconnect alerts are enabled but no vehicle yards are configured. Alerts will not trigger until at least one yard is added on the General Settings page.', 'warning', 15000)
        } else {
          this.$emit('showAlert', 'Configuration Saved', 'success',5000)
        }
      } catch(e) {
        this.$emit('showAlert', this._saveErrorMessage(e), 'danger', 5000)
      }
      finally {
        this.saving = false
      }
    },
    setup_yards_to_save() {
      if (this.selectedYardOptions != null && this.selectedYardOptions != "") {
        this.model.late_alert_yards = this.selectedYardOptions.join()
      } else {
        this.model.late_alert_yards = ""
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item, field, setting) {
      if (item[field] !== setting) {
        this.$set(item, field, setting)
      }
    },
    toggle_div(item, field) {
      this.$set(item, field, !item[field])
    },
    eval_event() {
      const types = this.add_vehicle_late_alert_model.event_types
      this.add_vehicle_late_alert_model.event_types = types
    },
    isEnabled(event) {
      if (event.event_types) {
        return (event.event_types.includes('Vehicle Not Near Spot'))
      } else {
        return false
      }
    },
    isNeverAtYardEnabled(event) {
      if (event.event_types) {
        return (event.event_types.includes('Vehicle Not Left'))
      } else {
        return false
      }
    },
    isEventTypeDisabled(eventType) {
      const selected = this.add_vehicle_late_alert_model.event_types || []
      if (selected.length === 0) return false
      const flatItems = group => group.columns ? group.columns.flat() : group.items
      const activeGroup = this.vehicle_late_alert_groups.find(group =>
        flatItems(group).some(item => selected.includes(item))
      )
      if (!activeGroup) return false
      return !flatItems(activeGroup).includes(eventType)
    },
    async hosModalOk($event) {
      this.add_hos_event_model = {}
      this.update_toggle_div(this.toggle, 'isHOSAddEventVisible', false)
    },
    async add_hos_event() {
      this.loading=true
      if (this.hos_alert_event_settings.length == 4) {
        const alert_event_item = this.hos_alert_event_settings.filter(element => element.eventName == this.add_hos_event_model.eventName)[0]
        if (alert_event_item) {
          this.save_hos_event()
        } else {
          this.cancel_save_hos_event()
        }
      } else {
        this.save_hos_event()
      }
    },
    async save_hos_event() {
      await add_hos_event(this.user.tenant, this.add_hos_event_model)
      this.add_hos_event_model = {}
      this.toggle_div(this.toggle, 'isHOSAddEventVisible')
      await this.load_data()
    },
    async cancel_save_hos_event() {
      this.toggle_div(this.toggle, 'isHOSAddEventVisible')
      this.manage_hos_events = false
      this.add_hos_event_model = {}
      await this.load_data()
    },
    async update_hos_event(event_name) {
      const alert_event_item = this.hos_alert_event_settings.filter(element => element.eventName == event_name)[0]
      if (alert_event_item) {
        this.update_toggle_div(this.toggle, 'isHOSAddEventVisible', true)
        this.add_hos_event_model = alert_event_item
      }
    },
    async delete_hos_event(event_name) {
      if (!confirm(`Remove alert event "${event_name}"? This cannot be undone.`)) return
      await delete_hos_event(this.user.tenant, event_name)
      this.hos_alert_event_settings = this.hos_alert_event_settings.filter(e => e.eventName !== event_name)
      this._sync_model_settings('driver_hos_alerts_settings', this.hos_alert_event_settings)
    },

    async vehicleLateModalOk($event) {
      this.error_msg = ""
      this.editing_vehicle_late_event_name = null
      this.add_vehicle_late_alert_model = this._default_vehicle_late_alert_model()
      // Pre-existing gap: filterErrors never gets cleared on modal open/close (only
      // on `loading` becoming true), so a stale red state from one edit session
      // could otherwise leak into the next. Clear this modal's filter keys here.
      VEHICLE_LATE_ALERT_MODAL_FILTER_KEYS.forEach(k => this.$set(this.filterErrors, `adv_late_${k}`, ''))
      this.update_toggle_div(this.toggle, 'isVehicleLateAddEventVisible', false)
    },
    async setupDefaultVehicleLateAlerts() {
      const settings = DEFAULT_VEHICLE_LATE_ALERT_SETTINGS_BY_TENANT_TYPE[this.tenant_type]
      if (!settings) {
        return
      }
      this.loading = true
      try {
        // Set Defaults only fills in whatever is missing - it must never touch an
        // event that already exists, whether or not it happens to share a default
        // name. Same existing_names guard as the "Add Default Events" button below.
        const existing_names = this.vehicle_late_alert_settings.map(e => e.eventName)
        for (const event of settings) {
          if (!existing_names.includes(event.eventName)) {
            await add_vehicle_late_alert_event(this.user.tenant, event)
          }
        }
        await this.load_data()
        this.$emit('showAlert', 'Default advanced late alerts configured', 'success', 5000)
      } catch (e) {
        this.$emit('showAlert', 'Error setting up default alerts, try logging in again or contact support if needed', 'danger', 5000)
      } finally {
        this.loading = false
      }
    },
    async add_vehicle_late_event() {
      this.error_msg = ""

      // FI-1976 follow-up: renaming onto a name already used by a different live
      // event used to leave that other event in place and append a duplicate -
      // both would then fire. Catch it here too so the user gets immediate
      // feedback instead of relying solely on the API-side guard.
      const new_event_name = this.add_vehicle_late_alert_model.eventName
      if (new_event_name && new_event_name !== this.editing_vehicle_late_event_name &&
          this.vehicle_late_alert_settings.some(e => e.eventName === new_event_name)) {
        this.error_msg = `An alert event named "${new_event_name}" already exists`
        return
      }

      const drv_st = this.add_vehicle_late_alert_model.driver_start != null ? this.add_vehicle_late_alert_model.driver_start.toLowerCase() : null;
      const dep = this.add_vehicle_late_alert_model.departure != null ? this.add_vehicle_late_alert_model.departure.toLowerCase() : null

      if (!this.add_vehicle_late_alert_model.eventName || (this.add_vehicle_late_alert_model.event_types===null || this.add_vehicle_late_alert_model.event_types.length===0) 
        || !this.add_vehicle_late_alert_model.sms_template || 
        (this.tenant_type == 'TBN' 
        && ( ((!drv_st || drv_st===null) && (!dep || dep===null))
        || ( (drv_st === 'True'.toLowerCase() && dep === 'True'.toLowerCase()) 
        || (drv_st ==='False'.toLowerCase() && dep === 'False'.toLowerCase()) ) ))) {
        if (!this.add_vehicle_late_alert_model.eventName) {
          this.error_msg = "Please add an Event Name"
        } 
        if (this.add_vehicle_late_alert_model.event_types === null || this.add_vehicle_late_alert_model.event_types.length===0) {
          this.error_msg = "Please add one or more Event Types"
        } 
        if (!this.add_vehicle_late_alert_model.sms_template) {
          this.error_msg = "Please add a template"
        }
        if (this.tenant_type == 'TBN') {
          if (((!drv_st || drv_st===null)) && ((!dep || dep===null))) {
            this.error_msg = "Please set EITHER Driver Start Time or First Departure Time to True"
          } else if ((drv_st === 'True'.toLowerCase() && dep === 'True'.toLowerCase()) ||
            (drv_st ==='False'.toLowerCase() && dep === 'False'.toLowerCase())) {
            this.error_msg = "Please set EITHER Driver Start Time or First Departure Time to True"
          }
        }
        this.loading = false
      } else {
        this.loading=true
        this.error_msg = ""
        this.save_vehicle_late_event()
      }
    },
    async save_vehicle_late_event() {
      const payload = this.editing_vehicle_late_event_name
        ? { ...this.add_vehicle_late_alert_model, original_event_name: this.editing_vehicle_late_event_name }
        : this.add_vehicle_late_alert_model
      try {
        await add_vehicle_late_alert_event(this.user.tenant, payload)
      } catch (e) {
        // FI-1976 follow-up: the client-side check in add_vehicle_late_event() catches
        // most cases, but the API is the source of truth (e.g. another tab/user renamed
        // a different event to this name after this modal's data was loaded) and now
        // rejects a colliding rename instead of silently no-oping. Surface that here too
        // instead of leaving the modal stuck in a loading state with no feedback.
        this.error_msg = (e.response && e.response.data && e.response.data.message) || 'Error saving alert event'
        this.loading = false
        return
      }
      this.editing_vehicle_late_event_name = null
      this.add_vehicle_late_alert_model = this._default_vehicle_late_alert_model()
      this.toggle_div(this.toggle, 'isVehicleLateAddEventVisible')
      await this.load_data()
    },
    async update_vehicle_late_event(event_name) {
      const alert_event_item = this.vehicle_late_alert_settings.filter(element => element.eventName == event_name)[0]
      if (alert_event_item) {
        this.editing_vehicle_late_event_name = event_name
        this.update_toggle_div(this.toggle, 'isVehicleLateAddEventVisible', true)
        this.add_vehicle_late_alert_model = { ...this._default_vehicle_late_alert_model(), ...alert_event_item }
        ensureFilterKeys(this.add_vehicle_late_alert_model, VEHICLE_LATE_ALERT_MODAL_FILTER_KEYS)
      }
    },
    async duplicate_vehicle_late_event(event_name) {
      const alert_event_item = this.vehicle_late_alert_settings.filter(element => element.eventName == event_name)[0]
      if (!alert_event_item) return
      let copy_name = `${event_name} (Copy)`
      let suffix = 2
      while (this.vehicle_late_alert_settings.some(e => e.eventName === copy_name)) {
        copy_name = `${event_name} (Copy ${suffix})`
        suffix++
      }
      // no editing_vehicle_late_event_name set - this is a new entry, saved as an add rather than a rename
      this.editing_vehicle_late_event_name = null
      this.add_vehicle_late_alert_model = { ...this._default_vehicle_late_alert_model(), ...alert_event_item, eventName: copy_name }
      this.update_toggle_div(this.toggle, 'isVehicleLateAddEventVisible', true)
    },
    cancel_edit_vehicle_late_event() {
      this.editing_vehicle_late_event_name = null
      this.add_vehicle_late_alert_model = this._default_vehicle_late_alert_model()
      this.toggle_div(this.toggle, 'isVehicleLateAddEventVisible')
    },
    async delete_vehicle_late_event(event_name) {
      if (!confirm(`Remove alert event "${event_name}"? This cannot be undone.`)) return
      await delete_vehicle_late_alert_event(this.user.tenant, event_name)
      this.vehicle_late_alert_settings = this.vehicle_late_alert_settings.filter(e => e.eventName !== event_name)
      this._sync_model_settings('vehicle_late_alert_settings', this.vehicle_late_alert_settings)
      if (this.add_vehicle_late_alert_model.eventName === event_name) {
        this.editing_vehicle_late_event_name = null
        this.add_vehicle_late_alert_model = this._default_vehicle_late_alert_model()
        this.update_toggle_div(this.toggle, 'isVehicleLateAddEventVisible', false)
      }
    },

    _default_booking_state_alert_model() {
      const model = {
        event_types: [],
        private_hires_enabled: 'True',
        contracts_enabled: 'True',
        poll_interval_hrs: '2',
      }
      if (this.tenant_type === 'TBN') {
        model.school_contracts_enabled = 'True'
      }
      return model
    },
    bookingStateTypeFilterLabel(item) {
      const enabled = []
      if (this.tenant_type === 'TBN') {
        if (item.private_hires_enabled !== 'False') enabled.push('Bookings')
        if (item.contracts_enabled !== 'False') enabled.push('Scheduled Services')
        if (item.school_contracts_enabled !== 'False') enabled.push('School Bus')
      } else if (this.tenant_type === 'CM') {
        if (item.contracts_enabled !== 'False') enabled.push('Contracts')
        if (item.private_hires_enabled !== 'False') enabled.push('Private Hires')
      }
      return enabled.length ? enabled.join(', ') : 'None'
    },

    async bookingStateModalOk($event) {
      this.error_msg = ""
      this.add_booking_state_alert_model = this._default_booking_state_alert_model()
      this.update_toggle_div(this.toggle, 'isBookingStateAddEventVisible', false)
    },
    open_add_booking_state_form() {
      if (!this.toggle.isBookingStateAddEventVisible) {
        this.add_booking_state_alert_model = this._default_booking_state_alert_model()
      }
      this.toggle_div(this.toggle, 'isBookingStateAddEventVisible')
    },
    async add_booking_state_event() {
      this.error_msg = ""
      if (!this.add_booking_state_alert_model.eventName) {
        this.error_msg = "Please add an Event Name"
        return
      }
      if (!this.add_booking_state_alert_model.event_types || this.add_booking_state_alert_model.event_types.length === 0) {
        this.error_msg = "Please select at least one Event Type"
        return
      }
      if (!this.add_booking_state_alert_model.email_recipients) {
        this.error_msg = "Please add Email Recipients"
        return
      }
      this.loading = true
      this.error_msg = ""
      await add_booking_state_alert_event(this.user.tenant, this.add_booking_state_alert_model)
      this.add_booking_state_alert_model = this._default_booking_state_alert_model()
      this.toggle_div(this.toggle, 'isBookingStateAddEventVisible')
      await this.load_data()
    },
    async update_booking_state_event(event_name) {
      const alert_event_item = this.booking_state_alert_settings.filter(element => element.eventName == event_name)[0]
      if (alert_event_item) {
        this.update_toggle_div(this.toggle, 'isBookingStateAddEventVisible', true)
        const item = { ...alert_event_item }
        if (item.event_types && !Array.isArray(item.event_types)) {
          item.event_types = [item.event_types]
        } else if (!item.event_types) {
          item.event_types = item.event_type ? [item.event_type] : []
        }
        this.add_booking_state_alert_model = { ...this._default_booking_state_alert_model(), ...item }
      }
    },
    async delete_booking_state_event(event_name) {
      if (!confirm(`Remove alert event "${event_name}"? This cannot be undone.`)) return
      if (this.add_booking_state_alert_model.eventName === event_name) {
        this.add_booking_state_alert_model = this._default_booking_state_alert_model()
        this.update_toggle_div(this.toggle, 'isBookingStateAddEventVisible', false)
      }
      await delete_booking_state_alert_event(this.user.tenant, event_name)
      this.booking_state_alert_settings = this.booking_state_alert_settings.filter(e => e.eventName !== event_name)
      this._sync_model_settings('booking_state_alert_settings', this.booking_state_alert_settings)
    },

    isPlainObject(value,key) {
      if (isPfsTemplateField(key)) return false
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value, key) {
      if (isPfsTemplateField(key)) return false
      return Array.isArray(value)
    },
    
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user,
      viewAs: state => state.profile.view_as,
    }),
    isEffectiveAdmin() {
      return this.user.role === 'admin' && this.viewAs !== 'non-admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    },
    lateAlertVoiceFields() {
      if (this.tenant_type === 'TBN') {
        return this.pfsAlertFields.lateAlertVoice.filter(f => f.name !== 'movementID')
      }
      return this.pfsAlertFields.lateAlertVoice
    },
    booking_state_alert_options_computed() {
      const raw = this.add_booking_state_alert_model.event_types || []
      const selected = Array.isArray(raw) ? raw : [raw]
      const actualsSelected = selected.includes('Invalid Actuals')
      const pretripsSelected = selected.some(t => t !== 'Invalid Actuals')
      return this.booking_state_alert_options.map(opt => ({
        ...opt,
        disabled: opt.value === 'Invalid Actuals' ? pretripsSelected : actualsSelected
      }))
    },
    booking_state_alert_table_fields() {
      return [
        'eventName',
        'event_types',
        { key: 'booking_types', label: 'Booking Types' },
        'hrs_before',
        'hrs_after',
        'email_recipients',
        'update',
        'remove',
      ]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";

.alerts-global-row {
  padding: 10px 0 10px 12px;
  font-size: 18px;
  font-weight: bold;
}
.alerts-global-label {
  min-width: 220px;
}
.alert-section-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
}
.tc-field-info {
  color: #9ca3af;
  cursor: help;
  font-size: 13px;
  margin: 0 4px;
}
.alert-section-header {
  cursor: pointer;
  user-select: none;
  background-color: #f8f9fa;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #dee2e6;
}
.alert-section-header:hover {
  background-color: #e9ecef;
}
.alert-section-header--static {
  cursor: default;
  user-select: auto;
}
.alert-section-header--static:hover {
  background-color: #f8f9fa;
}
.alert-section-title {
  color: var(--fi-rail-accent);
  font-size: 17px;
}
.alert-chevron {
  display: inline-block;
  font-size: 12px;
  color: #666;
  transition: transform 0.2s ease;
}
.alert-chevron.open {
  transform: rotate(90deg);
}
.alert-settings-table td {
  vertical-align: middle;
  padding: 6px 10px;
}
.alert-settings-table td.alert-label {
  text-align: right;
  width: 340px;
  font-weight: 500;
  color: #444;
  white-space: nowrap;
}
.alert-settings-table td:not(.alert-label) {
  text-align: left;
}
</style>
